export class OrganizationSettingDM {
  constructor({
    enable_faciltiy_checking = 0,
    enable_referral_page = 0,
    step_activity_limit = 0,
    enable_activity_tracker = 0,
    activate_stars = 0,
    membership_setting = 0,
    membership_trial_period = 0,
    activate_points = 0,
    group_activation = 0,
    user_max_member_group = 0,
    event_multiple_ticket = 0,
    appreaciation_approval = 0,
  }) {
    this.enable_faciltiy_checking = enable_faciltiy_checking;
    this.enable_referral_page = enable_referral_page;
    this.step_activity_limit = step_activity_limit;
    this.enable_activity_tracker = enable_activity_tracker;
    this.activate_stars = activate_stars;
    this.membership_setting = membership_setting;
    this.membership_trial_period = membership_trial_period;
    this.activate_points = activate_points;
    this.group_activation = group_activation;
    this.user_max_member_group = user_max_member_group;
    this.event_multiple_ticket = event_multiple_ticket;
    this.appreaciation_approval = appreaciation_approval;
  }

  toJson() {
    return {
      enable_facility_checkin: this.enable_faciltiy_checking,
      enable_referral_page: this.enable_referral_page,
      step_activity_limit: this.step_activity_limit,
      enable_activity_tracker: this.enable_activity_tracker,
      activate_stars: this.activate_stars,
      membership_setting: this.membership_setting,
      membership_trial_period: this.membership_trial_period,
      activate_points: this.activate_points,
      group_activation: this.group_activation,
      user_max_member_group: this.user_max_member_group,
      event_multiple_ticket: this.event_multiple_ticket,
      appreciation_approval: this.appreaciation_approval,
    };
  }

  static fromJson(json) {
    return new OrganizationSettingDM({
      enable_faciltiy_checking: json["enable_facility_checkin"],
      enable_referral_page: json["enable_referral_page"],
      step_activity_limit: json["step_activity_limit"],
      enable_activity_tracker: json["activate_stars"],
      activate_stars: json["activate_stars"],
      membership_setting: json["membership_setting"],
      membership_trial_period: json["membership_trial_period"],
      activate_points: json["activate_points"],
      group_activation: json["group_activation"],
      user_max_member_group: json["user_max_member_group"],
      event_multiple_ticket: json["event_multiple_ticket"],
      appreaciation_approval: json["appreciation_approval"],
    });
  }
}
